import { ModelBase } from '../shared/base/model-base';
import { ObjectObservable } from '../shared/base/object-observable';
import { User } from '../users/shared/user';

export class Notification extends ModelBase {
  type: string;
  user?: string;
  userObservable?: ObjectObservable<User>;
  timestamp?: number;
  content?: string;
  lecture?: string;
  discussion?: string;
  course?: string;
  discussionWriter?: string;
  discussionWriterObservable?: ObjectObservable<User>;
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/notifications/notification.ts